import { createClient as createSdkClient, type SupabaseClient } from "@supabase/supabase-js";

export interface SupabaseEnv {
  url: string | undefined;
  anonKey: string | undefined;
}

export function createSupabaseClient(env: SupabaseEnv): SupabaseClient {
  if (!env.url) {
    throw new Error("VITE_SUPABASE_URL manquant : configurer .env.local");
  }
  if (!env.anonKey) {
    throw new Error("VITE_SUPABASE_ANON_KEY manquant : configurer .env.local");
  }
  return createSdkClient(env.url, env.anonKey, {
    auth: {
      flowType: "pkce",
      detectSessionInUrl: false,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

let cachedClient: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (cachedClient) return cachedClient;
  cachedClient = createSupabaseClient({
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  });
  return cachedClient;
}
